<template>
	<div>
    <input class="input" type='text' v-model="meterIdArray"></input>
    <button @click="sendMeterIds">Generate Graph></button></div>
</template>

<script>
export default {
  name: 'MeterComponent',
 data() {
		return {
            meterIdArray:[]
		}
    },
    methods: {
        sendMeterIds(){
            this.$emit('sendmeters',this.meterIdArray)
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


